<template>
  <div id="certificates-page">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button icon="fas fa-plus" type="primary" size="small" round @click="$router.push({ name: 'add-certificate' })"> {{ $t("onsiteUtilities.digitalCertificate.create") }}</el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.certificastes.title") }}</h5>
              <span v-if="certificates.length > 0" v-html="$t('totalContent', [certificates.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/what-is-certificate-desinger-how-to-use-and-send-certificate')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="certificates.length > 0" :key="certificatesKey">
            <div id="wrapper_" class="certificates-wrapper">
              <div class="certificate-item" :key="item.id" v-for="item in certificates" :style="'max-width: ' + width + 'px;'">
                <div class="certificate-item-certificate" :style="'height: ' + getHeight(item) + ';'">
                  <div class="certificate-item-certificate-inner" v-html="item.details" :style="'transform: scale(' + getScale(item) + ');'"></div>
                </div>
                <div class="certificate-bottom">
                  <div class="certificate-title">
                    {{ item.title }}
                  </div>
                  <div class="d-flex align-center cert-btns">
                    <el-tooltip class="item" effect="dark" :content="$t('event.buttons.copy')" placement="top-end">
                      <el-button circle size="mini" type="warning" :loading="loading == 'copy-' + item.id" icon="fas fa-clone" @click="copyCertificate(item)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-end">
                      <el-button icon="fas fa-pen" type="success" circle size="mini" @click="$router.push({ name: 'add-certificate', params: { id: item.id } })"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-end">
                      <el-popconfirm :confirm-button-text="$t('event.variables.yes')" :cancel-button-text="$t('event.variables.no')" icon="el-icon-info" @confirm="removeItem(item.id)" icon-color="red" :title="$t('message.sureDelCert')">
                        <el-button circle icon="fas fa-trash" type="danger" size="mini" slot="reference"> </el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-certificate-lottie-v2'" :title="$t('event.menu.certificastes.title')" @btnAdd="$router.push({ name: 'add-certificate' })" @btnRefresh="refreshList()" :buttonAdd="true" :buttonRefresh="true" :loading="loading" />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
 metaInfo() {
    return {
      title: this.$t("eventPageTitle.certificates")
    };
  },
  components: {},
  name: "Certificates",
  data() {
    return {
      width: 1,
      certificatesKey: +new Date(),
      loading: false,
      listShort: false,
      certificates: [],
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "certificates"
    };
  },
  methods: {
    async copyCertificate(item) {
      this.loading = "copy-" + item.id;
      var copy = JSON.parse(JSON.stringify(item));
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        copy.id = null;
        copy.title = "Copy of " + copy.title;
        copy.expireDate = null;
        var res = await axios.post("certificate/addorupdate", copy);
        if (!res.data.alert.hasError) {
          await this.getCertificatesList();
        } else {
          this.$message.error(res.data.alert.message);
        }
        this.loading = false;
      }, 500);
    },
    async removeItem(id) {
      var index = this.certificates.findIndex(k => k.id == id);
      var res = await axios.post("Certificate/Delete", { id });
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
      } else {
        this.$message.success(res.data.alert.message);
        this.certificates.splice(index, 1);
      }
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.getCertificatesList();

      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    getHeight(item) {
      item = JSON.parse(item.jsonData);
      return item.height * (this.width / item.width) + "px";
    },
    getScale(item) {
      item = JSON.parse(item.jsonData);
      return this.width / item.width;
    },
    itemUpdated(item) {
      var index = this.$store.state.areamaps.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.areamaps.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getAreaMaps");
    },
    handleSizeChange(take) {
      this.$store.commit("setAreaMapTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setAreaMapPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deleteAreaMap", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleAreaMap", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedAreaMaps", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async getCertificatesList() {
      var res = await axios.post("/Certificate/List", { searchTerm: null, skip: 0, take: 1000 });
      this.certificates = res.data.data.items;
    }
  },
  async mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      var resFont = await axios.post("certificate/listfonts", { skip: 0, take: 1000 });
      this.fonts = resFont.data.data.items;
      this.fonts.map(k => {
        var head = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = k.url;
        head.appendChild(link);
      });

      this.width = ($("#wrapper_").width() - 30) / 3;
      this.loading = false;
    }, 500);
  },

  async created() {
    await this.getCertificatesList();
    this.certificatesKey += 1;
  },
  computed: {
    skip() {
      return (this.$store.state.areamaps.filter.page - 1) * this.$store.state.areamaps.filter.take;
    },
    take() {
      return this.skip + this.$store.state.areamaps.items.length;
    }
  },
  watch: {
    certificatesKey: function() {
      this.width = ($("#wrapper_").width() - 30) / 3;
    },
    "$store.state.areamaps.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getAreaMaps");
      }, 500);
    }
  }
};
</script>

<style lang="less">
#certificates-page {
  .certificates-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
    width: 100%;
    gap: 10px;

    .certificate-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      border-radius: 8px;
      overflow: hidden;
      background-color: #fbfbfb;
      border: 0.5px solid #f1f3f6;

      .certificate-item-certificate {
        width: 100%;
        position: relative;
        overflow: hidden;

        .certificate-item-certificate-inner {
          transform-origin: left top;
          width: 100%;
          #_canvas {
            box-shadow: unset;
            margin: unset;
            .ui-icon {
              background: none !important;
            }

            .ui-resizable-handle.ui-icon {
              display: none !important;
            }

            .ui-resizable-handle.ui-icon {
              display: none !important;
              border-width: 0 !important;
              border-color: transparent !important;
            }
          }
        }
      }
      .certificate-bottom {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: #f1f1f1;
        padding: 10px 14px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;

        .certificate-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 220px;
        }

        .cert-btns {
          gap: 0.2rem;

          .el-button + .el-button {
            margin-left: 0px;
          }

          button {
            &:last-child {
              margin-left: unset;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Certificates.vue